import { EyeFill } from "react-bootstrap-icons";

//Common
import useIconStyles from "./styles";
import { IconProps } from "../../../types";

const ViewIcon = (props: IconProps) => {
    const { iconText = "View", pendingText } = props;
    const iconStyles = useIconStyles();

    return (
        <div style={iconStyles.container}>
            <EyeFill style={iconStyles.viewIcon} />
            <div style={iconStyles.iconText}>
                {iconText} {pendingText}
            </div>
        </div>
    );
};

export default ViewIcon;
